import axios from 'axios';

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || 'http://localhost:3001', // BFF server URL
  headers: {
    'Content-Type': 'application/json',
  },
});

// Check for existing token on startup
const token = localStorage.getItem('token');
if (token) {
  api.defaults.headers.common['Authorization'] = `Bearer ${token}`;
}

// Request interceptor
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor
api.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response?.status === 401 && error.config.url !== '/backend/login') {
      // Token expired or invalid (but not during login attempt)
      localStorage.removeItem('token');
      window.location.href = '/login'; // Redirect to login page
    }
    console.error('API Error:', error);
    return Promise.reject(error);
  }
);

export default api;

// Example API functions
export const getProducts = () => api.get('/backend/products');
export const getProduct = (id) => api.get(`/backend/products/${id}`);
export const createProduct = (data) => api.post('/backend/products', data);
export const updateProduct = (id, data) => api.put(`/backend/products/${id}`, data);
export const deleteProduct = (id) => api.delete(`/backend/products/${id}`);

// Auth functions
export const login = (username, password) => {
  console.log('Making login request to:', `${api.defaults.baseURL}/backend/login`);
  return api.post('/backend/login', { username, password });
};
